import { render } from "./SaleFeedback.vue?vue&type=template&id=13101ae2&scoped=true"
import script from "./SaleFeedback.vue?vue&type=script&lang=js"
export * from "./SaleFeedback.vue?vue&type=script&lang=js"

import "./SaleFeedback.vue?vue&type=style&index=0&id=13101ae2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13101ae2"]])

export default __exports__